
import clientAPI from "@/api/ClientAPIMixin.js";
//import Vue from "vue"

export const BackgroundUpdater = {
    namespaced: true,

    state: () => ({
        /*
        KeyName: {
            Value: null,                            //Holds the current value
            Loading: false,                         //Is true during a check reuest.
            ClientMethod: "GetJobStatusMap",        //String of method defined in clentAPI.
            Interval: 15000,                        //Interval for data refresh. Defined in miliseconds. (Avoid very small value.)
            Updater: null,                          //Holds setInterval object when started.
            DontInitialize: true,                   //Exempts this item from pre-loading.

        }
        */

        StatusMap: {
            Value: null,
            Loading: false,
            ClientMethod: "GetJobStatusMap",
            Interval: 60000, //1 minute
        },

        AssignmentMap: {
            Value: null,
            Loading: false,
            ClientMethod: "getJobAssignmentMap",
            Interval: 300000, //5 minutes
        },

        JobTypeList: {
            Value: null,
            Loading: false,
            ClientMethod: "getJobTypes",
            Interval: 300000, //5 minutes
        },

        PriorityList: {
            Value: null,
            Loading: false,
            ClientMethod: "GetJobPriorityList",
            Interval: 300000, //5 minutes
        },

        WarrantyTypeList: {
            Value: null,
            Loading: false,
            ClientMethod: "getWarrantyTypeList",
            Interval: 300000, //5 minutes
        },

        RepairLocationList: {
            Value: null,
            Loading: false,
            ClientMethod: "getRepairPlaceList",
            Interval: 300000, //5 minutes
        },

        JobCategoryList: {
            Value: null,
            Loading: false,
            ClientMethod: "getJobCategories",
            Interval: 300000, //5 minutes
        },

        ContractTypeMap: {
            Value: null,
            Loading: false,
            ClientMethod: "getContractTypeMap",
            Interval: 300000, //5 minutes
        },
    }),

    mutations: {
        SET_UPDATE(state, update) {
            const { key, value } = update;
            state[key].Value = value
            //Vue.set(state[key], "Value", value );
        },
    },

    actions: {
        PreLoading({ state, dispatch }) {
            Object.keys(state).forEach(key => {
                if (!state[key].DontInitialize) {
                    dispatch('Start', key)
                }
            });
        },

        Start({ state, dispatch }, key) {
            var wrapper = state[key];
            if (wrapper) {
                if (!wrapper.Updater) {
                    if (wrapper.LogUpdates) { console.log('[BU] starting ' + key); }
                    dispatch("Checker", key)
                    state[key].Updater = setInterval(() => { dispatch("Checker", key) }, wrapper.Interval);
                }
                else { console.error('[BU] Could not start, allready started;', key); }
            }
            else { console.error('[BU] Could not start, invalid key;', key); }
        },

        Checker({ state, commit, dispatch }, key) {
            var wrapper = state[key];
            if (wrapper) {
                if (wrapper.LogUpdates) { console.log('[BU] checking ' + key); }
                wrapper.Loading = true;
                clientAPI.methods[wrapper.ClientMethod]()
                    .then(response => {
                        wrapper.Loading = false;
                        if (wrapper.LogUpdates) { console.log('[BU] ' + key + ': ', response); }
                        commit('SET_UPDATE', { key: key, value: response });
                    }).catch((error) => {
                        wrapper.Loading = false;
                        console.error('[BU] Error, terminating;', key, error);
                        dispatch("Stop", key)
                    });
            }
            else { console.error('[BU] Invalid key;', key); }
        },

        Setter({ state, commit }, { key, value }) {
            var wrapper = state[key];
            if (wrapper) {
                if (wrapper.LogUpdates) { console.log('[BU] set' + key + ': ', value); }
                commit('SET_UPDATE', { key: key, value: value });
            }
            else { console.error('[BU] Invalid key;', key); }
        },

        Stop({ state }, key) {
            var wrapper = state[key];
            if (wrapper) {
                if (wrapper.LogUpdates) { console.log('[BU] stopping ' + key); }
                clearInterval(state[key].Updater);
            }
            else { console.error('[BU] Could not stop, invalid key;', key); }
        },

        StopAll({ state }) {
            Object.keys(state).forEach(key => {
                if (!state[key].DontInitialize) {
                    clearInterval(state[key].Updater);
                }
            });
        },
    },

    getters: {
        Wrapper: (state) => (key) => {
            if (state[key]) {
                return state[key];
            }
            else {
                console.error('[BU] Falied to get value for ' + key);
                return 'UNKNOWN_BACKGROUND_UPDATER'
            }
        },

        Value: (state) => (key) => {
            if (state[key]) {
                return state[key].Value;
            }
            else {
                console.error('[BU] Falied to get wrapper for ' + key);
                return 'UNKNOWN_BACKGROUND_UPDATER'
            }
        },

        Loading: (state) => (key) => {
            if (state[key]) {
                return state[key].Loading;
            }
            else {
                console.error('[BU] Falied to get loading state for ' + key);
                return 'UNKNOWN_BACKGROUND_UPDATER'
            }
        },
    }
}